import loadImages from '../loadImages';
import HubfulApplication from './HubfulApplication';
loadImages();
new HubfulApplication().start();